import { Component } from '@angular/core';

@Component({
  selector: 'csl-top-slim-banner',
  templateUrl: './top-slim-banner.component.html'
})
export class TopSlimBannerComponent {

}
